module.exports = __webpack_public_path__ + "img/ROROCCCO01100154.4d657334.png";